import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { saveNavigationHistory } from '@recruitee/dashboard-logic';
import type { NgrxRoute } from '@recruitee/ngrx';

import { ListPageComponent } from './pages/list/list-page.component';
import { AccessDeniedPageComponent } from './pages/single-requisition/access-denied/access-denied-page.component';
import { requisitionSnapshotResolver } from './resolvers/requisition-snapshot.resolver';
import { RequisitionsListResolver } from './resolvers/requisitions-list.resolver';

const routes: NgrxRoute[] = [
  {
    path: '',
    component: ListPageComponent,
    resolve: {
      fetchData: RequisitionsListResolver,
    },
  },
  {
    path: 'access-denied',
    component: AccessDeniedPageComponent,
  },
  {
    path: ':id',
    resolve: {
      historySnapshot: saveNavigationHistory(requisitionSnapshotResolver),
    },
    loadChildren: () =>
      import('./pages/single-requisition/single-requisition.module').then(
        m => m.SingleRequisitionModule,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class RequisitionsRoutingModule {}
